// ABOUTME: Transformation schema mapping TechLog engine oil uplifts to Rusada Additional Oil & Fuel rows.
import { TechLogToRusadaOilUpliftInput } from './validation';

export const techlogOilUpliftToRusadaSchema = {
  flightId: (input: TechLogToRusadaOilUpliftInput) => input.rusada.flightId,

  uplifts: (input: TechLogToRusadaOilUpliftInput) => {
    // TechLog offers a fluid row per destination whether or not anyone fills it in,
    // so a row with no quantity holds nothing to sync.
    const engineOil = input.techlog.fluidUplifts.filter(
      (fluid) =>
        fluid.fluidType === 'oil' &&
        fluid.fluidDestination === 'engine' &&
        !!fluid.uplift,
    );
    if (!engineOil.length) return [];

    return input.rusada.additionalOilAndFuel.flatMap((row) => {
      // Engine oil lives under ATA 72, positioned by the Veryon lifecode convention:
      // LH is engine 1, RH is engine 2, and a single-engine aircraft leaves the
      // position empty. Every other row is a fluid location we have no oil for.
      if (!row.location.trim().startsWith('72')) return [];

      const position = row.position.trim().toUpperCase();
      const engineNumber =
        position === '' || position === 'LH' ? 1 : position === 'RH' ? 2 : 0;
      if (!engineNumber) return [];

      const upliftsForEngine = engineOil.filter(
        (fluid) => fluid.fluidDestinationNumber === engineNumber,
      );
      if (!upliftsForEngine.length) return [];

      const unitOfMeasure = row.upliftUnitOfMeasure.toLowerCase();
      const techlogUnit = /litre|liter/.test(unitOfMeasure)
        ? 'ml'
        : unitOfMeasure.includes('quart')
        ? 'qt'
        : undefined;

      // Writing quarts into a litres row (or an unnameable unit) records a wrong
      // volume against the aircraft, which is worse than not writing at all.
      const conflictingUplift = upliftsForEngine.find(
        (fluid) => fluid.upliftUnit !== techlogUnit,
      );
      if (conflictingUplift) {
        throw new Error(
          `TechLog oil uplift ${conflictingUplift.id} is recorded in ${conflictingUplift.upliftUnit} but Veryon oil row ${row.location} ${row.position} is configured in "${row.upliftUnitOfMeasure}"`,
        );
      }

      const total = upliftsForEngine.reduce(
        (sum, fluid) => sum + (fluid.uplift ?? 0),
        0,
      );

      return [
        { ...row, upliftUsage: techlogUnit === 'ml' ? total / 1000 : total },
      ];
    });
  },
};

export default techlogOilUpliftToRusadaSchema;
